
import { Component, Prop, Vue } from 'vue-property-decorator';
import ActivityPrice from '@/models/activity_price';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import TextEditor from '@/components/inputs/TextEditor.vue';

@Component({
	components: {
		TextEditor,
		ValidationProvider,
		ValidationObserver,
	},
})
export default class ActivityPrices extends Vue {
	@Prop({ default: null, required: true }) private activity_prices;
	@Prop({ default: null, required: false }) private errors;

	private prices: ActivityPrice[] = [];

	$refs!: {
		obs: InstanceType<typeof ValidationObserver>;
	};

	mounted() {
		if (this.activity_prices) {
			this.prices = this.activity_prices;
		}
	}

	addPriceRow() {
		this.prices.push(new ActivityPrice());
	}

	deletePrice(activityPrice) {
		const index = this.prices.indexOf(activityPrice);
		this.prices.splice(index, 1);
	}

	async validate() {
		this.$emit('input', this.prices);
		return await this.$refs.obs.validate();
	}
}
